import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from "react-router-dom";
import "./CarouselComponent.css"
import projects from "assets/projects_info";

const CarouselComponent = () => {

  const landingProjects = ["lorong-n-telok-kurau", "tuas-south-ave-16-plg", "richards-avenue-33", "teo-hock-7"]
  const carouselItems = [];

  landingProjects.forEach((proj) => {
    let project = projects.find((p) => p.id === proj);
    if (project) {
      carouselItems.push(project);
      console.log(project)
    }
  });

  return (
    <Carousel>
      {carouselItems.map((item, index) => (
        <Carousel.Item key={index}>
          <Link className="link" to={`/work/${item.id}`} key={item.id}>
            <img
              className="d-block w-100 img"
              // /images/Lorong N Telok Kurau/Masterbedroom.jpeg
              src={`${item.thumbnail}`}
              alt={`Slide ${index}`}
            />
          </Link>
          <Carousel.Caption>
            <h3 className='carousel-caption'>
              <span className='carousel-caption-category'> {item.type} : </span>
              <br></br>
              <span className='carousel-caption-name'> {item.title}  </span>
            </h3>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default CarouselComponent;